// Anything exported from this file is importable by other in-browser modules.
import { mainPushEventDataLayer } from "./utils/mainPushEventDatalayer";
import { handleVpvEvent } from "./utils/events/vpv/vpv";
import { handleSearchEvent } from "./utils/events/search/search";
import { handleAddToCartSellEvent } from "./utils/events/add_to_cart_sell/addToCartSell";
import { handlePurchaseEvent } from "./utils/events/purchase/purchase";
import { handlerBeginCheckoutHandler } from "./utils/events/begin_checkout/begin-checkout";
import { handleFaresCache } from "./utils/events/fares_cache/faresCache";
import { handleVpvPaymentEvent } from "./utils/events/vpv_payment/vpvPayment";
import {
  handleAddPaymentInfoEvent,
  handleSelectPaymentMethodEvent,
  handleConfirmedPaymentMethodEvent,
} from "./utils/events/payment";
import { handleAddToCartEvent } from "./utils/events/add_to_cart/add_to_cart";
import { AddToCartDto } from "./utils/events/add_to_cart/add_to_cart.dto";
import { handleGenericErrorEvent } from "./utils/events/generic_error/generic_error";
import { GenericErrorDto } from "./utils/events/generic_error/generic_error.dto";
import { getRegistry } from "./utils/services/registry";
import { RegistryDto } from "./utils/services/registry.dto";
import { INITIAL_SALE_EVENT_CONTEXT } from "./constants";
import { AncEventDto } from "./utils/events/generic_anc_event/anc_event.dto";
import { handleAncEvent } from "./utils/events/generic_anc_event/anc_event";
import { BusinessVpvEvent } from "./utils/events/business/vpv/vpv_business";
import { BusinessInteractEvent, BusinessInteractPaymentEvent } from "./utils/events/business/interact/interact_business";
import { handleVpvRegisterEvent } from "./utils/events/vpv_register/vpvRegister";
import { handleRegisterSuccessEvent } from "./utils/events/register_success/registerSuccess";
import { handleVpvCreateBusinessEvent } from "./utils/events/vpv_create_business_event/vpvCreateBusinessEvent";
import { handleLoginOpenEvent } from "./utils/events/login_open/loginOpen";
import { handleRegisterOpenEvent } from "./utils/events/register_open/registerOpen";
import { ISelectItemBundleEvent, ItemSelectPayloadDto } from "./utils/events/select_item_bundle/selectItem.dto";
import { handleSelectItemInItinerarySelection } from "./utils/events/select_item_itinerary/selectItem";
import { handleSelectItemInBundleSelection } from "./utils/events/select_item_bundle/selectItem";
import { ISelectItemItineraryEvent } from "./utils/events/select_item_itinerary/selectItem.dto";
import { CheckInVpvEvent } from "./utils/events/check-in/impl/vpv_reg_ex";
import { CheckInInteractionsEvent } from "./utils/events/check-in/impl/interactions";
import { MMBEvent } from "./utils/events/mmb/impl/event";
import { BusinessInteractFrequentPassengers } from "./utils/events/business/interact/interact_frequent_passengers";

export function createMainPushEventDataLayer(data) {
  mainPushEventDataLayer(data);
}

export function createVpvEvent(data, rest: any) {
  const dtoMapped = handleVpvEvent(data, rest);
  mainPushEventDataLayer(dtoMapped);
}

export function createVpvRegisterEvent(data) {
  const dtoMapped = handleVpvRegisterEvent(data);
  mainPushEventDataLayer(dtoMapped);
}

export function createVpvBusinessEvent(data) {
  const dtoMapped = handleVpvCreateBusinessEvent(data);
  mainPushEventDataLayer(dtoMapped);
}

export function createLoginOpenEvent(data) {
  const dtoMapped = handleLoginOpenEvent(data);
  mainPushEventDataLayer(dtoMapped);
}

export function createRegisterOpenEvent(data) {
  const dtoMapped = handleRegisterOpenEvent(data);
  mainPushEventDataLayer(dtoMapped);
}

export function createRegisterSuccessEvent(data) {
  const dtoMapped = handleRegisterSuccessEvent(data);
  mainPushEventDataLayer(dtoMapped);
}

export function createAddToCartSellEvent(data) {
  const dtoMapped = handleAddToCartSellEvent(data);
  mainPushEventDataLayer(dtoMapped);
}

export const createPurchaseEvent = (registry) => {
  const dtoMapped = handlePurchaseEvent(registry);
  mainPushEventDataLayer(dtoMapped);
};

export const createBeginCheckOutEvent = async (idRegistry) => {
  const { env, isApp, isCorpo } = JSON.parse(
    localStorage.getItem(INITIAL_SALE_EVENT_CONTEXT) || "{}"
  );
  const data = {
    environment: env,
    app: isApp,
    corp: isCorpo,
  };

  const response = await getRegistry(idRegistry);
  const dtoMapped = handlerBeginCheckoutHandler(data, response.registry as RegistryDto );
  mainPushEventDataLayer(dtoMapped);
};

export const createFaresCacheEvent = (data, rest: any, isRoundtrip) => {
  const dtoMapped = handleFaresCache(data, rest, isRoundtrip);
  mainPushEventDataLayer(dtoMapped);
};

export const createVpvPaymentEvent = (data) => {
  const dtoMapped = handleVpvPaymentEvent(data);
  mainPushEventDataLayer(dtoMapped);
};

export function createAddPaymentInfoEvent(data) {
  const dtoMapped = handleAddPaymentInfoEvent(data);
  mainPushEventDataLayer(dtoMapped);
}

export function createSelectPaymentMethodEvent(data) {
  const dtoMapped = handleSelectPaymentMethodEvent(data);
  mainPushEventDataLayer(dtoMapped);
}

export function createConfirmedPaymentMethodEvent(data) {
  const dtoMapped = handleConfirmedPaymentMethodEvent(data);
  mainPushEventDataLayer(dtoMapped);
}

export function createAddToCartEvent(data: AddToCartDto) {
  const dtoMapped = handleAddToCartEvent(data);
  mainPushEventDataLayer(dtoMapped);
}

export function createGenericErrorEvent(data: GenericErrorDto) {
  const dtoMapped = handleGenericErrorEvent(data);
  mainPushEventDataLayer(dtoMapped);
}

export function createAncEvent(data: AncEventDto) {
  const dtoMapped = handleAncEvent(data);
  mainPushEventDataLayer(dtoMapped);
}

export function createSelecteItemInBundleSelection(data: ItemSelectPayloadDto) {
  const dtoMapped: ISelectItemBundleEvent = handleSelectItemInBundleSelection(data);
  mainPushEventDataLayer(dtoMapped);
}

export function createSelecteItemInCardFlightSelection(data, rest) {
  const dtoMapped: ISelectItemItineraryEvent = handleSelectItemInItinerarySelection(data, rest);
  mainPushEventDataLayer(dtoMapped);
}

// Business Events
export const CreateBusinessEventDataLayer = (data) => {
  const businessVpvEvent = BusinessVpvEvent(data);
  mainPushEventDataLayer(businessVpvEvent);
}

export const CreateBusinessInteractEventDataLayer = (data) => {
  const businessInteractEvent = BusinessInteractEvent(data);
  mainPushEventDataLayer(businessInteractEvent);
};

export const CreateBusinessPaymentInteractEventDataLayer = (data) => {
  const businessInteractPaymentEvent = BusinessInteractPaymentEvent(data);
  mainPushEventDataLayer(businessInteractPaymentEvent);
};

export const CreateBusinessFrequentPassengersInteractEventDataLayer = async (
  data: any,
  idRegistry: string
) => {
  const response = await getRegistry(idRegistry);

  const businessInteractEvent = BusinessInteractFrequentPassengers(
    data,
    response.registry as RegistryDto
  );
  mainPushEventDataLayer(businessInteractEvent);
};

export function CreateSearchEvent(data, rest: any) {
  const dtoMapped = handleSearchEvent(data, rest);
  mainPushEventDataLayer(dtoMapped);
}

export const CreateCheckInVPVEventDataLayer = (data) => {
  const data_to_layer = CheckInVpvEvent(data);
  mainPushEventDataLayer(data_to_layer);
};

export function CreateCheckInInteractionEventDataLayer(data) {
  const data_to_layer = CheckInInteractionsEvent(data);
  mainPushEventDataLayer(data_to_layer);
}

export function CreateMMBEVPVEventDataLayer(data) {
  const data_to_layer = MMBEvent(data);
  mainPushEventDataLayer(data_to_layer);
}

export function CreateMMBEInteractionDataLayer(data) {
  const data_to_layer = MMBEvent(data);
  mainPushEventDataLayer(data_to_layer);
}

export {
  IS_PURCHASE_EXECUTED_FLAG,
  IS_SEATS_REQUEST,
  IS_SELECTED_SEATS,
  IS_SELECTED_SERVICES,
  INITIAL_SALE_EVENT_CONTEXT,
} from "./constants";
